// removed by extract-text-webpack-plugin
module.exports = {"feedback":"app-pages-Customers-Feedback-__style-feedback___gv5Uk","mk-action-bar":"app-pages-Customers-Feedback-__style-feedback___15j2v","table-feedback":"app-pages-Customers-Feedback-__style-feedback___2IWin","box-scroll":"app-pages-Customers-Feedback-__style-feedback___K54E5","feedback-row":"app-pages-Customers-Feedback-__style-feedback___18agJ"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/Feedback/style.feedback.css
// module id = 764
// module chunks = 0